<template>
    <section id="story" class="SectionStory text-white relative">
        <div class="container-lg relative">
            <div class="row">
                <div
                    class="col-lg-6 relative "
                    data-aos="fade-up"
                    data-aos-once="true"
                    data-aos-duration="1000"
                >
                    <div class="frame relative">
                        <div class="bg text-center">
                            <h2
                                class="font-bold "
                                data-aos="fade-up"
                                data-aos-once="true"
                                data-aos-duration="2000"
                            >
                                Our Story
                            </h2>
                            <div
                                class="description "
                                data-aos="fade-up"
                                data-aos-once="true"
                                data-aos-duration="2500"
                            >
                                MRT Organic Green Products, most reliable and
                                resourceful Cultivators, Distillers and
                                Extractors of Conventional and Organic Plant
                                derived ingredients and products based at
                                Cochin, India_ More than 35000 progressive
                                farmers working in 2,80,000 Hectares of fertile
                                land spread over 29 states of India and 13
                                countries make MRT Sustainable Development
                                Mission of producing high quality plant
                                materials for making Essential oils, Cold
                                Pressed Oils, Ayurvedic Oils, Co2 Extracts and
                                many other food products.
                            </div>
                            <!-- <a
                                href="#"
                                class="more"
                                data-aos="fade-up"
                                data-aos-once="true"
                                data-aos-duration="2900"
                                >Read more</a
                            > -->
                            <router-link
                                to="/about"
                                class="more"
                                data-aos="fade-up"
                                data-aos-once="true"
                                data-aos-duration="2900"
                                tag="a"
                                exact
                            >Read more</router-link>
                        </div>
                        <img
                            src="/assets/custom/img/zooom-img.jpg"
                            data-src="/assets/custom/img/zooom-img.jpg"
                            width="557"
                            height="680"
                            alt="assets/custom/img/zooom-img.jpg"
                            class="w-100 zoom-image"
                        />
                    </div>
                </div>
                <img
                    src="/assets/custom/img/vector.png"
                    data-src="/assets/custom/img/vector.png"
                    width="755"
                    height="601"
                    alt="vector image"
                    class="vector zoomIn"
                    data-aos="zoom-in"
                    data-aos-once="true"
                    data-aos-duration="3000"
                />

                <div
                    class="col-lg-6 "
                    data-aos="fade-up"
                    data-aos-once="true"
                    data-aos-duration="2000"
                >
                    <div
                        class="content-2 text-center "
                        data-aos="fade-up"
                        data-aos-once="true"
                        data-aos-duration="1500"
                    >
                        <img
                            src="/assets/custom/img/logo-white.png"
                            data-src="/assets/custom/img/logo-white.png"
                            width="300"
                            height="58"
                            alt="logo"
                            class="logo"
                        />
                        <h3
                            class="font-bold "
                            data-aos="fade-up"
                            data-aos-once="true"
                            data-aos-duration="2500"
                        >
                            Farmer
                        </h3>
                        <h4
                            class="font-normal "
                            data-aos="fade-up"
                            data-aos-once="true"
                            data-aos-duration="2800"
                        >
                            The Backbone of our nation
                        </h4>
                        <div
                            class="icon "
                            data-aos="fade-up"
                            data-aos-once="true"
                            data-aos-duration="3100"
                        >
                            <img
                                src="/assets/custom/img/icon-leaf.png"
                                data-src="/assets/custom/img/icon-leaf.png"
                                width="48"
                                height="54"
                                alt="leaf"
                            />
                        </div>
                        <div
                            class="large font-bold "
                            data-aos="fade-up"
                            data-aos-once="true"
                            data-aos-duration="3500"
                        >
                            MRT Organic salutes farmers whose sweat awakens the
                            sleeping soul of earth
                        </div>
                    </div>
                </div>
            </div>
            <img
                src="/assets/custom/img/leaf-2.png"
                data-src="/assets/custom/img/leaf-2.png"
                width="327"
                height="315"
                alt="leaf"
                class="leaf"
                data-aos="zoom-in"
                data-aos-duration="3000"
            />
        </div>
        <div class="wall"></div>
    </section>
</template>

<script>
export default {
    name: "Story"
};
</script>
